import React from "react";

export default function IT() {
  return (
    <div className="page">
      <h1>IT Solutions</h1>
      <p>Overview of IT services.</p>
    </div>
  );
}
